import http from './http'

class Payer {
  get (id) {
    return http.get(`/payers/${id}`)
  }

  save (payload) {
    return http.post(`/payers`, { payer: payload })
  }

  update (payload) {
    return http.put(`/payers/${payload.id}`, { payer: payload })
  }

  getCurrent () {
    return http.get('/current_payer')
  }

  fetch () {
    return http.get('/payers?per_page=100&simple=true&status=active')
  }

  byCampaign () {
    return http.get('/payers_for_campaign')
  }

  getAssignors (id) {
    return http.get(`/find_assignors_by_payer/${id}`)
  }

  paymentNotifications (id) {
    return http.get(`/payer_payment_notifications/${id}/contacts/`)
  }

  sendEmail (payload) {
    return http.post(`/payer_payment_notifications/${payload.assignment_request_id}/resend/`, { contact_ids: payload.contacts_ids })
  }
}

export default new Payer()



// WEBPACK FOOTER //
// ./src/services/payer.js